var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 64,
    viewBox: "0 0 90 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.194 28.8806C71.194 44.8309 58.2637 57.7612 42.3134 57.7612C26.3631 57.7612 13.4328 44.8309 13.4328 28.8806C13.4328 12.9303 26.3631 0 42.3134 0C58.2637 0 71.194 12.9303 71.194 28.8806Z",
    fill: "#E92127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73134 41.9776C8.73134 44.3887 6.77677 46.3433 4.36567 46.3433C1.95458 46.3433 0 44.3887 0 41.9776C0 39.5665 1.95458 37.6119 4.36567 37.6119C6.77677 37.6119 8.73134 39.5665 8.73134 41.9776Z",
    fill: "#E92127"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56.4179C90 60.4982 86.6923 63.806 82.6119 63.806C78.5316 63.806 75.2239 60.4982 75.2239 56.4179C75.2239 52.3376 78.5316 49.0299 82.6119 49.0299C86.6923 49.0299 90 52.3376 90 56.4179Z",
    fill: "#E92127"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2959 18.4997C67.2705 13.9323 67.0679 11.4587 65.4544 9.84518C63.6092 8 60.6394 8 54.6999 8L52.5999 8C46.6604 8 43.6906 8 41.8454 9.84518C40.0002 11.6904 40.0002 14.6601 40.0002 20.5997L40.0002 37.3993C40.0002 43.3388 40.0002 46.3086 41.8454 48.1538C43.6906 49.999 46.6604 49.999 52.5999 49.999L54.6999 49.999C60.6394 49.999 63.6092 49.999 65.4544 48.1538C67.0679 46.5402 67.2705 44.0667 67.2959 39.4992",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7002 29L81.9995 29M81.9995 29L74.6497 22.7001M81.9995 29L74.6497 35.2998",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.aa46859683054a9a0b9163e38e5efbb6.svg";
export { ForwardRef as ReactComponent };